import React, {useEffect, useState} from 'react';
import {Button, Form, Input, message, Modal} from 'antd';
import ForgotPasswordModal from "../modals/ForgotPasswordModal";

interface PasswordChangeModalProps {
    open: boolean;
    onClose: () => void;
}

const PasswordChangeModal: React.FC<PasswordChangeModalProps> = ({open, onClose}) => {
    const [form] = Form.useForm();
    const [showForgotPassword, setShowForgotPassword] = useState(false);

    useEffect(() => {
        if (open) {
            form.resetFields();
        }
    }, [open, form]);

    const handleOk = () => {
        form
            .validateFields()
            .then(values => {
                if (values.newPassword !== values.confirmPassword) {
                    void message.error('Les mots de passe ne correspondent pas');
                    return;
                }
                // Appel à l’API à implémenter plus tard
                void message.success('Mot de passe modifié avec succès (simulation)');
                onClose();
            })
            .catch(info => {
                console.log('Erreur lors de la validation:', info);
            });
    };

    const clickForgotPassword = () => {
        // Open ForgotPassword component
        setShowForgotPassword(true);
        // Optionally, you can also reset the form or handle any other logic here
        form.resetFields();
    };

    return (
        <>
            <Modal
                title="Changer le mot de passe"
                open={open}
                onCancel={() => {
                    form.resetFields(); // clear form when closing
                    onClose();
                }}
                onOk={handleOk}
                okText="Valider"
                cancelText="Annuler"
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Ancien mot de passe"
                        name="oldPassword"
                        rules={[{required: true, message: 'Veuillez saisir votre ancien mot de passe'}]}
                    >
                        <Input.Password/>
                    </Form.Item>

                    <Form.Item
                        label="Nouveau mot de passe"
                        name="newPassword"
                        rules={[{required: true, message: 'Veuillez saisir un nouveau mot de passe'}]}
                    >
                        <Input.Password/>
                    </Form.Item>

                    <Form.Item
                        label="Confirmer le mot de passe"
                        name="confirmPassword"
                        rules={[{required: true, message: 'Veuillez confirmer votre nouveau mot de passe'}]}
                    >
                        <Input.Password/>
                    </Form.Item>

                    <Button type="link"
                            onClick={clickForgotPassword}>
                        Mot de passe oublié ?
                    </Button>
                </Form>
            </Modal>

            <ForgotPasswordModal
                open={showForgotPassword}
                onCancel={() => {
                    setShowForgotPassword(false);
                    onClose();
                }}
            />
        </>

    );
};

export default PasswordChangeModal;
